/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MdsGps } from './mdsGps';

export interface MdsTrip { 
    provider_id: string;
    device_id: string;
    trip_id: string;
    trip_type?: MdsTrip.TripTypeEnum;
    start_time: number;
    end_time: number;
    duration: number;
    distance: number;
    start_location: MdsGps;
    end_location: MdsGps;
    actual_cost?: number;
    standard_cost?: number;
    currency?: string;
}
export namespace MdsTrip {
    export type TripTypeEnum = 'rider' | 'rebalance' | 'maintenance';
    export const TripTypeEnum = {
        Rider: 'rider' as TripTypeEnum,
        Rebalance: 'rebalance' as TripTypeEnum,
        Maintenance: 'maintenance' as TripTypeEnum
    };
}